<template>
  <component :is="component" :class="className">
    <slot />
  </component>
</template>

<script>
export default {
  props: {
    level: {
      type: Number,
      default: 2
    },
    override: {
      type: String,
      default: null
    }
  },
  computed: {
    component() {
      return `h${this.level}`
    },
    className() {
      if (this.override) {
        return this.override
      }

      if (this.level === 1) {
        return 'font-heading text-2xl sm:text-4xl font-extrabold bg-clip-text bg-linear-to-r from-accent-600 to-purple-700 dark:from-accent-500 dark:to-purple-500 text-transparent leading-12'
      }
      if (this.level === 2) {
        return 'font-heading text-xl sm:text-2xl font-semibold text-black dark:text-white'
      }
      if (this.level === 3) {
        return 'text-lg font-semibold text-black dark:text-white'
      }
      if (this.level === 4) {
        return 'font-semibold text-black dark:text-white'
      }
      return 'font-semibold text-black dark:text-white'
    }
  }
}
</script>
